import React, { useState } from "react";
import "./User.scss";
import TokenService from "../../services/authentication/token.service";
import UserProfile from "./UserProfile";
import UserHeader from "./UserHeader";
import UserTab from "./UserTab";

const User: React.FC = () => {
  const storedUserData = TokenService.getUser();
  const [activeTab, setActiveTab] = useState("profile");
  const tabs = [{ label: "Profile", value: "profile" }];
  return (
    <>
      <div className="content-wrapper">
        <UserHeader
          fullName={`${storedUserData?.user?.firstName} ${storedUserData?.user?.lastName}`}
          company="ChampionX"
        />
       <div className="divider"></div>
        <UserTab
          tabs={tabs}
          activeTab={activeTab}
          //onTabChange={(val) => setActiveTab(val)}
        />
        <div className="">
          <div className="flex flex-wrap items-center justify-between pl-[15px] xl:pl-[32px] pr-[15px] xl:pr-[32px] py-[12px]">
            <UserProfile value={storedUserData?.user} />
          </div>
        </div>
      </div>
    </>
  );
};

export default User;
